import { CategoryDetailsContainer } from '@/modules/Categories';

const CategoryDetails = (): JSX.Element => <CategoryDetailsContainer />;

export default CategoryDetails;
